<script>
  import {getContext} from 'svelte';
  import {IMAGES_NEWS} from '@/const/images';
  import {env} from '@/helper/env';
  import {lang$} from '@/store/lang';
  import Page from '@/modules/components/Page.svelte';
  import Header from '@/modules/header/Header.svelte';
  import Footer from '@/modules/footer/Footer.svelte';
  import Banner from './components/Banner.svelte';
  import Menu from './components/Menu.svelte';
  import Crypto from './components/Crypto.svelte';
  import Step from './components/Step.svelte';
  import Product from './components/Product.svelte';
  import Recommend from './components/Recommend.svelte';
  import Download from './components/Download.svelte';
  import Brand from './components/Brand.svelte';
  import Press from './components/Press.svelte';
  import Duty from './components/Duty.svelte';
  import Marquee from './components/Marquee.svelte';
  import SoulPass from './components/SoulPass.svelte';
  import Knowledge from './components/Knowledge.svelte';
  import JpBanner from './components/JpBanner.svelte';
  import JpIntroductions from './components/JpIntroductions.svelte';
  import lang from './HomePage.lang';

  const LG = getContext('LG');
  const koSchema =
    `<script type="application/ld+json">
        {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "name": "페멕스",
            "alternateName": "Phemex, phemax, femex, phmex, fimex, fhemex, phamex, phemix, feemex, pfemex, phenmex, femax, pehemex, phemmex, phemwx, phemez, phemec, pheemx, pjemex, phemix, phemx, pheemex, phimex",
            "url": "https://phemex.com/ko",
            "email":"support@phemex.zendesk.com",
            "slogan":"페멕스 | Phemex | 간편한 암호화폐 거래소 | 비트코인",
            "description":"블록체인 업계에서 TOP 10안에 드는 페멕스 거래소는 계약거래와 수수료 없는 현물거래를 제공합니다.",
            "logo": "https://static.phemex.com/pubimg/6e844d113f03a766036d6730df029389ef391801070ec278d9a3054751bb6599.png",
            "sameAs": [
              "https://www.facebook.com/PhemexKorea/",
              "https://twitter.com/phemex_Korean",
              "https://blog.naver.com/phemex2019",
              "https://open.kakao.com/o/gq7qQ5Sb",
              "https://t.me/Phemex_Korean",
              "https://phemex.com/ko"
            ],
            "foundingdate":"2019"
          }
     </` + 'script>';
  const enSchema =
    `<script type="application/ld+json">
        {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "name": "Phemex",
            "alternateName": "phemax, femex, phmex, fimex, fhemex, phamex, phemix, feemex, pfemex, phenmex, femax, pehemex, phemmex, phemwx, phemez, phemec, pheemx, pjemex, phemix, phemx, pheemex, phimex",
            "url": "https://phemex.com/",
            "email":"support@phemex.zendesk.com",
            "slogan":"Phemex, Trade Simple",
            "description":"Phemex is the fastest Crypto exchange and Crypto Futures trading platform. Trade Bitcoin with Zero Fees. You can also trade perpetual contracts with 100x Leverage.",
            "logo": "https://static.phemex.com/pubimg/6e844d113f03a766036d6730df029389ef391801070ec278d9a3054751bb6599.png",
            "sameAs": [
            "https://www.facebook.com/Phemex.official",
            "https://twitter.com/phemex_official",
            "https://www.instagram.com/phemexofficial/?hl=en",
            "https://www.youtube.com/channel/UCtPeiP4cn2K19fH3y7o2tOg",
            "https://www.linkedin.com/company/phemex/",
            "https://phemex.com/"
            ],
            "foundingdate":"2019"
        }
      </` + 'script>';
  const jaSchema =
    `<script type="application/ld+json">
          {
            "@context": "https://schema.org",
            "@type": "Corporation",
            "name": "Phemex",
            "alternateName": "フェメックス, phemax, femex, phmex, fimex, fhemex, phamex, phemix, feemex, pfemex, phenmex, femax, pehemex, phemmex, phemwx, phemez, phemec, pheemx, pjemex, phemix, phemx, pheemex, phimex",
            "url": "https://phemex.com/ja",
            "email":"support@phemex.zendesk.com",
            "slogan":"シンプルに取引",
            "description":"最も信頼できる仮想通貨＆デリバティブ取引プラットフォーム",
            "logo": "https://static.phemex.com/pubimg/6e844d113f03a766036d6730df029389ef391801070ec278d9a3054751bb6599.png",
            "sameAs": [
              "https://twitter.com/PhemexJP",
              "https://t.me/Phemex_Japanese",
              "https://www.youtube.com/channel/UCxty1OmqDH3cXvbzALSxhSA",
              "https://phemex.com/ja"
            ],
            "foundingdate":"2019"
          }
      </` + 'script>';
  const ruSchema =
    `<script type="application/ld+json">
       {
          "@context": "https://schema.org",
          "@type": "Corporation",
          "name": "Phemex",
          "alternateName": "phemax, femex, phmex, fimex, fhemex, phamex, phemix, feemex, pfemex, phenmex, femax, pehemex, phemmex, phemwx, phemez, phemec, pheemx, pjemex, phemix, phemx, pheemex, phimex",
          "url": "https://phemex.com/ru",
          "email":"support@phemex.zendesk.com",
          "slogan":"Phemex, торговать просто",
          "description":"Самая быстрая платформа для торговли криптовалютами и фьючерсами. Спотовая торговля с нулевыми комиссиями. Торговля с кредитным плечом до 100х.",
          "logo": "https://static.phemex.com/pubimg/6e844d113f03a766036d6730df029389ef391801070ec278d9a3054751bb6599.png",
          "sameAs": [
            "https://twitter.com/PhemexR",
            "https://t.me/Phemex_Russian",
            "https://vk.com/phemex_official",
            "https://phemex.com/ru"
          ],
          "foundingdate":"2019"
        }
      </` + 'script>';
  const schemaList = {
    en: enSchema,
    ru: ruSchema,
    ko: koSchema,
    ja: jaSchema,
  };
</script>

<style>
  :global(html) {
    overflow-anchor: none;
  }
</style>

<svelte:head>
  <title>{LG(lang.Title)}</title>
  <meta name="description" content={LG(lang.Description)} />
  <meta name="keywords" content={LG(lang.Keywords)} />
  <meta name="og:title" content={LG(lang.OGTitle)} />
  <meta name="og:description" content={LG(lang.OGDescription)} />
  <meta name="og:image" content={IMAGES_NEWS.OG_NORMAL} />
  <meta name="facebook-domain-verification" content="lyiqrvhuqlwultn0bumowbcu3cziwr" />
  <meta name="naver-site-verification" content="f7192400993ce86b6e21a0f14eb8af81b5ce096d" />
  <meta name="google-site-verification" content="QOhl_Voo3aJ1tHzGTr4cE7PP_-Vhs3reIvDFVU08yaY" />
</svelte:head>
<Page>
  {@html schemaList[$lang$] || enSchema}
  <Header isHome />
  {#if env.isJapanSite === true}
    <JpBanner />
    <JpIntroductions />
  {:else}
    <Banner />
    <Menu />
    <Recommend />
  {/if}
  <Crypto />
  <SoulPass />
  <Step />
  <Product />
  <Download />
  <Brand />
  <Press />
  <Marquee />
  <Duty />
  <Knowledge />
  <Footer />
</Page>
